/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  inviteParents: {
    id: 'app.components.AdminUsers.inviteParents',
    defaultMessage: 'Invite Parents',
  },
  individualParent: {
    id: 'app.components.AdminUsers.individualParent',
    defaultMessage: 'Individual Parent',
  },
  findStudent: {
    id: 'app.components.AdminUsers.findStudent',
    defaultMessage: "To invite the parent(s) of a student, search the student and click on the 'Invite' link in the 'Parents' section",
  },
  manyParents: {
    id: 'app.components.AdminUsers.manyParents',
    defaultMessage: 'Multiple Parents',
  },
});
